module.exports = __webpack_public_path__ + "b25bb9d299fe0751dbeadaba563b0eef.MP3";